import { CustomTheme } from '@gorila-shared-ui/components';
import { CaptureDuration, StreamingTimezone, ZoomLevel } from '../types/streaming';

export const ZOOM_LEVELS: ZoomLevel[] = [
  { label: '24 horas', durationMinutes: 24 * 60, staticDuration: 15 },
  { label: '20 horas', durationMinutes: 20 * 60, staticDuration: 13 },
  { label: '16 horas', durationMinutes: 16 * 60, staticDuration: 10.5 },
  { label: '12 horas', durationMinutes: 12 * 60, staticDuration: 7.5 },
  { label: '8 horas', durationMinutes: 8 * 60, staticDuration: 5 },
  { label: '4 horas', durationMinutes: 4 * 60, staticDuration: 2.5 },
  { label: '1 hora', durationMinutes: 60, staticDuration: 0.65 },
  { label: '45 minutos', durationMinutes: 45, staticDuration: 0.47 },
  { label: '30 minutos', durationMinutes: 30, staticDuration: 0.33 },
  { label: '15 minutos', durationMinutes: 15, staticDuration: 0.16 },
  { label: '10 minutos', durationMinutes: 10, staticDuration: 0.11 },
  { label: '5 minutos', durationMinutes: 5, staticDuration: 0.055 },
];

export const CAPTURE_DURATION_CONVERSION_RATE = {
  [CaptureDuration.fiveSeconds]: 5 / 60,
  [CaptureDuration.tenSeconds]: 10 / 60,
  [CaptureDuration.thirtySeconds]: 30 / 60,
  [CaptureDuration.oneMinute]: 1,
  [CaptureDuration.fiveMinutes]: 5,
};

export const CAPTURE_DURATION = {
  [CaptureDuration.fiveSeconds]: 5,
  [CaptureDuration.tenSeconds]: 10,
  [CaptureDuration.thirtySeconds]: 30,
  [CaptureDuration.oneMinute]: 60,
  [CaptureDuration.fiveMinutes]: 60 * 5,
};

export const CAPTURE_DURATION_LABEL = {
  [CaptureDuration.fiveSeconds]: '5 seg',
  [CaptureDuration.tenSeconds]: '10 seg',
  [CaptureDuration.thirtySeconds]: '30 seg',
  [CaptureDuration.oneMinute]: '1 min',
  [CaptureDuration.fiveMinutes]: '5 min',
};

export const STREAMING_TIMEZONE_COLORS = {
  [StreamingTimezone.past]: CustomTheme.colors.brown500,
  [StreamingTimezone.current]: CustomTheme.colors.blue500,
  [StreamingTimezone.future]: CustomTheme.colors.purple500,
  [StreamingTimezone.outOfZone]: CustomTheme.colors.teal500,
};
